var MultipleGuestModel = require('../../../app/models/multiple-guest/multiple-guest');

var MultipleGuestServiceProviderView = require('./multiple-guest-service-provider');

var MultipleGuestView = Backbone.Epoxy.View.extend({
  template: 'multiple-guest.multipleGuest',
  itemView: MultipleGuestServiceProviderView,

  bindings: {
    '.js-multi-guest-block__collection': 'collection: $collection'
  },

  events: { },

  initialize: function(options) {
    options = options || {};

    this.model = options.model || new MultipleGuestModel();
    this.collection = this.model.get('serviceProviders');
    this.requireGuests = options.requireGuests || function() { return false; }
  },

  beforeRender: function() {
    return this.model != null;
  },

  afterRender: function() {
    this.applyBindings();
  },

  cleanup: function() {
    this.removeBindings();
  },

  updateOverWaitTimeShown: function (isOverWaitTime) {
    this.model.set('overWaitTimeShown', isOverWaitTime);
  },

  removeGuest: function(model) {
    this.collection.remove(model);
    this.model.reIndexGuests();
    this.model.set('numberOfGuests', this.model.get('numberOfGuests') - 1);
    this.trigger('finishRender');

  }
});

module.exports = MultipleGuestView;
